module.exports = __webpack_public_path__ + "static/media/cq_ordinamento_def b.3efb9fcd.svg";